<template>
  <layout-image-default :meals="meals" />
</template>

<script>
import LayoutImageDefault from "./layout-image-default"

export default {
  maxMeals: LayoutImageDefault.maxMeals,
  slicer: LayoutImageDefault.slicer,
  name: "layout-image-default-with-number",
  props: ["meals"],
  components: { LayoutImageDefault }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

::v-deep .meal-jumbo {
  .meal-number {
    display: unset;
    position: absolute;
    left: 0.1em;
    top: 0.1em;
    background-color: rgba(238, 238, 238, 0.88);
    height: 1.5em;
    width: 1.5em;
    border-radius: 52%;
    border: #222 solid 1px;
    font-size: 7em;
    text-align: center;
  }
}
</style>
